module.exports = __webpack_public_path__ + "img/lock-icon.cd696c37.svg";